var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"id":"fieldset-1","label":"メモ"}},[_c('b-form-textarea',{attrs:{"placeholder":"15時帰社予定","rows":"3","max-rows":"6"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }